<project-details-default-header [project]="project"></project-details-default-header>
<div class="logbook-section box_default box_white">
  
  <header>
      <h3>LOGGED EVENTS</h3>
  </header>
  <article class="logbook-section-main" *ngIf="pageStatus == STATUS_DONE">
    <div class="logbook-search">
      <projects-logbook-search-main></projects-logbook-search-main>
    </div>
    <div class="tab-nav">
      <project-details-logbook-events-list 
        [project]="project" 
        [events]="events" 
        [searching]="activeSearch"
      ></project-details-logbook-events-list>
    </div>
  </article>
  <div class="loader app-loader" [hidden]="pageStatus != STATUS_LOADING">
    <div class="dimmed" >
      <div class="dimmed_box"></div>
      <div class="dimmed_flex"><div class="dimmed_title"></div><div class="dimmed_subtitle"></div></div>
      <div class="dimmed_flex"><div class="dimmed_title"></div><div class="dimmed_subtitle"></div></div>
      <div class="dimmed_flex"><div class="dimmed_title"></div><div class="dimmed_subtitle"></div></div>
    </div>
  </div>
</div >
